import { Button, type ButtonProps } from '@teamsparta/stack-button';
import { ActionThumbUp } from '@teamsparta/stack-icons';
import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';

interface Props extends ButtonProps {
  count?: number;
  liked?: boolean;
}

export function LikeButton({
  count = 0,
  liked = false,
  style,
  ...props
}: Props) {
  return (
    <Button
      leftAddon={
        <ActionThumbUp
          size={16}
          variant={liked ? 'fill' : 'line'}
          color={vars.neutral[5]}
        />
      }
      size='sm'
      colorScheme='secondary'
      variant='outline'
      style={{
        width: 100,
        border: liked ? `1px solid ${vars.neutral[10]}` : undefined,
        ...style,
      }}
      {...props}
    >
      <Text as='span' font='captionSb' color='#EEF3F6'>
        좋아요 {count}
      </Text>
    </Button>
  );
}
